import React from 'react';
import { Box, Typography, Switch, FormControlLabel, Slider } from '@mui/material';

/**
 * MapControls - Controls for accuracy toggle, trails toggle, and max time gap slider
 */
export default function MapControls({
  showAccuracy,
  onAccuracyChange,
  showTrails,
  onTrailsChange,
  maxTimeGapMinutes,
  onMaxTimeGapChange,
  showTimeGap
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showTimeGap && showTrails && (
        <Box sx={{ minWidth: 180, mr: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            Max gap: {maxTimeGapMinutes} min
          </Typography>
          <Slider
            value={maxTimeGapMinutes}
            onChange={(e, newValue) => onMaxTimeGapChange(newValue)}
            min={0}
            max={60}
            step={1}
            size="small"
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value} min`}
            sx={{ flex: 1 }}
          />
        </Box>
      )}

      {showTimeGap && (
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showTrails}
              onChange={(e) => onTrailsChange(e.target.checked)}
            />
          }
          label={<Typography variant="caption">Trails</Typography>}
          sx={{ mr: 1 }}
        />
      )}

      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={showAccuracy}
            onChange={(e) => onAccuracyChange(e.target.checked)}
          />
        }
        label={<Typography variant="caption">Accuracy</Typography>}
        sx={{ mr: 1 }}
      />
    </Box>
  );
}
